import { render, staticRenderFns } from "./signup.component.html?vue&type=template&id=182e94da&scoped=true&"
import script from "./signup.component.ts?vue&type=script&lang=ts&"
export * from "./signup.component.ts?vue&type=script&lang=ts&"
import style0 from "./signup.component.scss?vue&type=style&index=0&id=182e94da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e94da",
  null
  
)

export default component.exports